/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Media from 'react-media';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
    array, bool, func,
} from 'prop-types';

import { getFeatureFlags, getPresentationFamily } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import MobileDesktopFacetsV3 from '../../GraphqlCategoryPage/Partials/ProductFacetsV3/MobileDesktopFacetsV3';
import GraphqlProductFacets from '../../GraphqlCategoryPage/Partials/GraphqlProductFacets/GraphqlProductFacets';

const useStyles = makeStyles((theme) => ({
    facetV3: {
        margin: '0px 7px',
    },
    productFacetsScrolling: {
        height: '100%',
        display: 'block',
        position: 'relative',
        verticalAlign: 'top',
        [theme.breakpoints.down(1025)]: {
            display: 'none',
        },
    },
    productFacetHidden: {
        display: 'none',
    },
}));

function GraphqlSearchFacetFilter({ desktop = false, productFacetsGroup, setFilterData }) {
    const classes = useStyles();
    const ssrDeviceType = useSelector(getSSRDeviceType);
    const featureFlags = useSelector(getFeatureFlags);
    const presentationFamily = useSelector(getPresentationFamily);
    const facetFilterEnabled = featureFlags['is-search-facet-filter-enabled'];

    const loadDesktopFacets = (onlyForQueryOps = false) => (
        <div className={onlyForQueryOps ? classes.productFacetHidden : classes.productFacetsScrolling}>
            <GraphqlProductFacets
                productFacets={productFacetsGroup}
                setFilterDataInCategoryBuilder={setFilterData}
                isFoodBrand
                isFacetFiltersCountEnabled={false}
                filterOn="Search"
                device={ssrDeviceType}
            />
        </div>
    );

    const loadProductFacetsV3 = () => (
        <div className={classes.facetV3}>
            <MobileDesktopFacetsV3
                isFoodBrand
                isFacetFiltersCountEnabled={false}
                filterOn="Search"
                isFacetFiltersEnabled={facetFilterEnabled && productFacetsGroup.length > 0}
                setFacetsDataInCollection={(data) => setFilterData(data, true)}
                setFilterDataInCategoryBuilder={(data) => setFilterData(data)}
                presentation_family={presentationFamily}
                productFacetsBase={productFacetsGroup}
            />
            {/* to stick with query pattern to be followed similar to collection facets  */}
            {loadDesktopFacets(true)}
        </div>
    );

    return (
        <Media
            queries={{
                small: '(max-width: 598px)',
                medium: '(min-width: 599px) and (max-width: 1024px)',
                large: '(min-width: 1025px)',
            }}
            defaultMatches={{
                small: ssrDeviceType === 'mobile',
                medium: ssrDeviceType === 'desktop',
                large: ssrDeviceType === 'desktop',
            }}
        >
            {(matches) => (
                <>
                    {(matches.small || matches.medium) && !desktop && loadProductFacetsV3()}
                    {matches.large && desktop && loadDesktopFacets()}
                </>
            )}
        </Media>
    );
}

GraphqlSearchFacetFilter.propTypes = {
    desktop: bool,
    productFacetsGroup: array.isRequired,
    setFilterData: func.isRequired,
};

GraphqlSearchFacetFilter.defaultProps = {
    desktop: false,
};

export default GraphqlSearchFacetFilter;
